<template>
    <div class="row">
        <div class="col-xs-12 col-lg-12">
            <div class="container-button-top">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <button class="button-edit button-cancel" :disabled="loading" @click="cancel" data-v-step-routing-form-step-1="1">
                            <i class="fa fa-fw fa-times"></i> CANCELAR
                        </button>
                        <button class="button-edit" style="float: right;" :disabled="loading" @click="nextStep" data-v-step-routing-form-step-1="2">
                            PRÓXIMA <i :class="'fa fa-fw ' + ((loading) ? 'fa-circle-notch fa-spin' : 'fa-caret-right')"></i>
                        </button>
                        <button class="btn button-edit button-cancel btn-right" @click="$refs.tour.editTour()">
                            <i class="fas fa-question-circle"></i> TOUR
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-lg-12">
            <div class="container-heading">
                <div class="row">
                    <div class="col-xs-12 col-lg-12 heading-page">
                        <small><b>Informações gerais</b> <span v-popover:tooltip.right="'Preencha o formulário com as informações gerais do roteiro'"><i class="fas fa-question-circle"></i></span></small>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-lg-12">
            <div class="container-body" data-v-step-routing-form-step-1="3">
                <div class="row">
                    <div class="col-xs-12 col-lg-9">
                        <FormInput v-model="name" label="Nome" icon="fa-route" type="text" :required="true" ref="name" tooltip="Informe o texto de identificação do roteiro" />
                    </div>
                    <div class="col-xs-12 col-lg-3">
                        <FormInput v-model="date" label="Data de embarque" icon="fa-calendar-alt" type="date" :min="min" :required="true" ref="date" tooltip="Informe a data de embarque das entregas" />
                    </div>
                    <div class="col-xs-12 col-lg-3">
                        <FormInput v-model="start_time" label="Horário inicial" icon="fa-business-time" type="time" ref="start_time" tooltip="Informe o horário estimado para o início" />
                    </div>
                    <div class="col-xs-12 col-lg-3">
                        <FormInput v-model="end_time" label="Horário final" icon="fa-business-time" type="time" ref="end_time" tooltip="Informe o horário estimado para o término" />
                    </div>
                    <div class="col-xs-12 col-lg-3">
                        <FormInput v-model="start_lunch_time" label="Horário inicial do almoço" icon="fa-utensils" type="time" ref="start_lunch_time" tooltip="Informe o horário estimado para início de intervalo ou almoço" />
                    </div>
                    <div class="col-xs-12 col-lg-3">
                        <FormInput v-model="end_lunch_time" label="Horário final do almoço" icon="fa-utensils" type="time" ref="end_lunch_time" tooltip="Informe o horário estimado para o fim de intervalo e almoço" />
                    </div>
                    <div class="col-xs-12 col-lg-4">
                        <FormInputMasked type="tel" v-model="average_speed" label="Velocidade média" icon="fa-tachometer-alt" :mask="['# km/h','## km/h','### km/h']" ref="average_speed" tooltip="Informe a velocidade média em trânsito dos veículos" />
                    </div>
                    <div class="col-xs-12 col-lg-4">
                        <FormInputMasked type="tel" v-model="discharge_weight_per_minut" label="Descarregamento peso por minuto" icon="fa-people-carry" :mask="['# kg/min','## kg/min','### kg/min','#### kg/min','##### kg/min','###### kg/min','####### kg/min','######## kg/min','######### kg/min']" ref="discharge_weight_per_minut" tooltip="Informe o tempo médio de descarregamento do peso por minuto" />
                    </div>
                    <div class="col-xs-12 col-lg-4">
                        <FormInputMasked type="tel" v-model="average_discharge_time" label="Tempo médio de descarregamento" icon="fa-people-carry" :mask="['# min','## min','### min','#### min','##### min']" ref="average_discharge_time" tooltip="Informe o tempo médio de descarregamento em cada cliente" />
                    </div>
                    <div class="col-xs-12 col-lg-12">
                        <FormSelect v-model="distribution_center" label="Centro de Distribuição" icon="fa-pallet" :options="options_my_dc" :required="true" ref="distribution_center" tooltip="Selecione o local de partida dos veículos do roteiro" />
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xs-12 col-lg-12">
            <div class="container-button-bottom">
                <div class="row">
                    <div class="col-xs-12 col-lg-12">
                        <button class="button-edit button-cancel" :disabled="loading" @click="cancel">
                            <i class="fa fa-fw fa-times"></i> CANCELAR
                        </button>
                        <button class="button-edit" style="float: right;" :disabled="loading" @click="nextStep">
                            PRÓXIMA <i :class="'fa fa-fw ' + ((loading) ? 'fa-circle-notch fa-spin' : 'fa-caret-right')"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <Tour
            tour="DeliveryRouting"
            :steps="tour_steps"
			ref="tour"
        />
    </div>
</template>

<script>
import FormInput from "@/components/FormInput";
import FormInputMasked from "@/components/FormInputMasked";
import FormSelect from "@/components/FormSelect";
import Tour from "@/components/Tour";

export default {
    name: "RoutingFormStep1",

    props: {
        data: {
            type: Object,
            require: true,
        },
        my_dcs: {
            type: Array,
            require: true,
        },
    },

    components: {
        FormInput,
        FormInputMasked,
        FormSelect,
        Tour,
    },

    data: function() {
        return {
            loading: false,
            name: this.data.name,
            date: this.data.date,
            min: this.data.min,
            start_time: this.data.start_time,
            end_time: this.data.end_time,
            start_lunch_time: this.data.start_lunch_time,
            end_lunch_time: this.data.end_lunch_time,
            average_speed: this.data.average_speed,
            discharge_weight_per_minut: this.data.discharge_weight_per_minut,
            average_discharge_time: this.data.average_discharge_time,
            correction_fact: this.$parent.data[1].correction_fact,
            distribution_center: this.data.distribution_center.id,
            
            tour_steps: [
                {
                    target: '[data-v-step-routing-form-step-1="0"]',
                    header: {
                        title: '<code>PASSO ATUAL</code>',
                    },
                    content: '<code>Verifique aqui o passo atual</code>',
                    params: {
                        placement: 'bottom',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-1="1"]',
                    header: {
                        title: '<code>CANCELAR</code>',
                    },
                    content: '<code>Clique em <b>CANCELAR</b> para interromper o processo e voltar para lista de roteiros</code>',
                    params: {
                        placement: 'right',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-1="2"]',
                    header: {
                        title: '<code>CONTINUAR</code>',
                    },
                    content: '<code>Clique em <b>PRÓXIMA</b> para avançar para a etapa seguinte</code>',
                    params: {
                        placement: 'left',
                        highlight: true,
                    }
                },
                {
                    target: '[data-v-step-routing-form-step-1="3"]',
                    header: {
                        title: '<code>FORMULÁRIO</code>',
                    },
                    content: '<code>Preencha os campos fundamentais para o processamento do roteirização</code>',
                    params: {
                        placement: 'top',
                        highlight: true,
                    }
                },
            ],
        }
    },

    mounted: function() {
        this.$refs.tour.setTour();
    },

    computed: {
        options_my_dc: function() {
			let r = {};
			this.my_dcs.map(dc => {
				r[dc.id] = dc.name.toUpperCase() + " - " + dc.street.toUpperCase() + ", " + dc.number.toUpperCase() + ", " + dc.neighborhood.toUpperCase() + " - " + dc.city.toUpperCase() + " / " + dc.uf.toUpperCase();
			});
			return r;
		},
    },

    methods: {
        // Retorna messagem de erro no campo determinado
        message: function(input) {
            return "'" + input + "' deve ser preenchido.";
        },

        // Verifica e valida inicialmente os campos
        validation: function() {
            this.loading = true;
            
            let result = {
                name: '',
                date: '',
                start_time: "",
                end_time: "",
                start_lunch_time: "",
                end_lunch_time: "",
                lunch_time: "",
                average_speed: "",
                average_discharge_time: "",
                discharge_weight_per_minut: "",
                distribution_center: "",
                time_constraints: false,
                weight_constraints: this.$parent.data[1].weight_constraints,
            };
            let error = false;

            // Nome
			if(this.name == "") {
                this.$refs.name.validate();
				this.$notification.error(this.message("NOME"));
                error = true;
			} else {
				result.name = this.name.toUpperCase();
			}

            // Data
			if(this.date == "") {
                this.$refs.date.validate();
                this.$notification.error(this.message("DATA DE EMBARQUE"));
                error = true;
			} else {
                let newDate = this.date.split("-");
                newDate = new Date(newDate[0], newDate[1] - 1, newDate[2], 23, 59, 59);
                if(newDate < new Date()) {
                    this.$refs.date.validate();
                    this.$notification.error("'DATA DE EMBARQUE' não pode ser menor que a data atual.");
                    error = true;
                } else {
                    result.date = this.date;
                }
            }
            
            // Verifica o preenchimento dos horários
            if((this.start_time != "") && (this.end_time != "")) {
                if(this.start_time >= this.end_time) {
                    this.$notification.error("'HORÁRIO DE INÍCIO' não pode ser maior, ou igual, ao 'HORÁRIO DE TÉRMINO'.");
                    this.$refs.start_time.error = "Horário inválido";
                    this.$refs.end_time.error = "Horário inválido";
                    error = true;
                } else {
                    result.start_time = this.start_time;
                    result.end_time = this.end_time;
                    result.time_constraints = true;
                }
            } else {
                if((this.start_time != "") && (this.end_time == "")) {
                    this.$notification.error("'HORÁRIO DE TÉRMINO' não preenchido.");
                    this.$refs.end_time.error = "Horário inválido";
                    error = true;
                }

                if((this.start_time == "") && (this.end_time != "")) {
                    this.$notification.error("'HORÁRIO DE INÍCIO' não preenchido.");
                    this.$refs.start_time.error = "Horário inválido";
                    error = true;
                }

                if((this.start_time == "") && (this.end_time == "")) {
                    result.time_constraints = false;
                }
            }
            
            // Verifica o preenchimento dos horários de almoço
            if((this.start_lunch_time != "") && (this.end_lunch_time != "")) {
                if(this.start_lunch_time >= this.end_lunch_time) {
                    this.$notification.error("'HORÁRIO DE INÍCIO DO ALMOÇO' não pode ser maior, ou igual, ao 'HORÁRIO DE TÉRMINO DO ALMOÇO'.");
                    this.$refs.start_lunch_time.error = "Horário inválido";
                    this.$refs.end_lunch_time.error = "Horário inválido";
                    error = true;
                } else {
                    result.start_lunch_time = this.start_lunch_time;
                    result.end_lunch_time = this.end_lunch_time;
                }
            } else {
                if((this.start_lunch_time != "") && (this.end_lunch_time == "")) {
                    this.$notification.error("'HORÁRIO DE TÉRMINO DO ALMOÇO' não preenchido.");
                    this.$refs.end_lunch_time.error = "Horário inválido";
                    error = true;
                }

                if((this.start_lunch_time == "") && (this.end_lunch_time != "")) {
                    this.$notification.error("'HORÁRIO DE INÍCIO DO ALMOÇO' não preenchido.");
                    this.$refs.start_lunch_time.error = "Horário inválido";
                    error = true;
                }
            }

            // Verifica o preenchimento dos horários
            if((this.start_time != "") && (this.end_time != "") && (this.start_lunch_time != "") && (this.end_lunch_time != "")) {
                if(this.start_time >= this.start_lunch_time) {
                    this.$notification.error("'HORÁRIO DE INÍCIO' não pode ser maior, ou igual, ao 'HORÁRIO DE INÍCIO DO ALMOÇO'.");
                    this.$refs.start_time.error = "Horário inválido";
                    this.$refs.start_lunch_time.error = "Horário inválido";
                    error = true;
                }

                if(this.start_time >= this.end_lunch_time) {
                    this.$notification.error("'HORÁRIO DE INÍCIO' não pode ser maior, ou igual, ao 'HORÁRIO DE TÉRMINO DO ALMOÇO'.");
                    this.$refs.start_time.error = "Horário inválido";
                    this.$refs.end_lunch_time.error = "Horário inválido";
                    error = true;
                }

                if(this.end_time <= this.start_lunch_time) {
                    this.$notification.error("'HORÁRIO DE TÉRMINO' não pode ser menor, ou igual, ao 'HORÁRIO DE INÍCIO DO ALMOÇO'.");
                    this.$refs.end_time.error = "Horário inválido";
                    this.$refs.start_lunch_time.error = "Horário inválido";
                    error = true;
                }

                if(this.end_time <= this.end_lunch_time) {
                    this.$notification.error("'HORÁRIO DE TÉRMINO' não pode ser menor, ou igual, ao 'HORÁRIO DE TÉRMINO DO ALMOÇO'.");
                    this.$refs.end_time.error = "Horário inválido";
                    this.$refs.end_lunch_time.error = "Horário inválido";
                    error = true;
                }
            }
            
            // Verifica a velocidade média
            if(this.average_speed != "") {
                let average_speed = this.average_speed.split(" ");
                if(average_speed.length == 2) {
                    if(parseInt(average_speed[0]) <= 0) {
                        this.$notification.error("'VELOCIDADE MÉDIA' não pode ser igual ou menor que zero.");
                        this.$refs.average_speed.error = "Valor inválido";
                        error = true;
                    } else {
                        result.average_speed = parseInt(average_speed[0]);
                    }
                } else {
                    this.$notification.error("'VELOCIDADE MÉDIA' inválida.");
                    this.$refs.average_speed.error = "Valor inválido";
                    error = true;
                }
            }

            // Verifica o descarregamento
            if((this.discharge_weight_per_minut != "") && (this.average_discharge_time != "")) {
                this.$notification.error("É necessário informar somente um dos dois campos, o 'DESCARREGAMENTO DE PESO POR MINUTO' ou o 'TEMPO MÉDIO DE DESCARREGAMENTO'.");
                this.$refs.discharge_weight_per_minut.error = "Valor inválido";
                this.$refs.average_discharge_time.error = "Valor inválido";
                error = true;
            } else {
                if(this.discharge_weight_per_minut != "") {
                    let discharge_weight_per_minut = this.discharge_weight_per_minut.split(" ");
                    if(discharge_weight_per_minut.length == 2) {
                        if(parseInt(discharge_weight_per_minut[0]) <= 0) {
                            this.$notification.error("'DESCARREGAMENTO DE PESO POR MINUTO' não pode ser igual ou menor que zero.");
                            this.$refs.discharge_weight_per_minut.error = "Valor inválido";
                            error = true;
                        } else {
                            result.discharge_weight_per_minut = parseInt(discharge_weight_per_minut[0]);
                            result.average_discharge_time = "";
                            this.$refs.average_discharge_time.error = "";
                        }
                    } else {
                        this.$notification.error("'DESCARREGAMENTO DE PESO POR MINUTO' inválido.");
                        this.$refs.discharge_weight_per_minut.error = "Valor inválido";
                        error = true;
                    }
                }
                if(this.average_discharge_time != "") {
                    let average_discharge_time = this.average_discharge_time.split(" ");
                    if(average_discharge_time.length == 2) {
                        if(parseInt(average_discharge_time[0]) <= 0) {
                            this.$notification.error("'TEMPO MÉDIO DE DESCARREGAMENTO' não pode ser igual ou menor que zero.");
                            this.$refs.average_discharge_time.error = "Valor inválido";
                            error = true;
                        } else {
                            result.average_discharge_time = parseInt(average_discharge_time[0]);
                            result.discharge_weight_per_minut = "";
                            this.$refs.discharge_weight_per_minut.error = "";
                        }
                    } else {
                        this.$notification.error("'TEMPO MÉDIO DE DESCARREGAMENTO' inválido.");
                        this.$refs.average_discharge_time.error = "Valor inválido";
                        error = true;
                    }
                }
            }
            
            // Centro de Distribuição
			if ((typeof this.distribution_center === "undefined") || (this.distribution_center == "")) {
                this.$refs.distribution_center.trigger_blur();
				this.$notification.error(this.message("CENTRO DE DISTRIBUIÇÃO"));
                error = true;
			} else {
                let dc = null;
                
                for(let i = 0; i < this.$parent.my_dcs.length; i++) {
                    if(this.distribution_center == this.$parent.my_dcs[i].id) {
                        dc = this.$parent.my_dcs[i];
                        break;
                    }
                }
                
                result.distribution_center = dc;
			}

            result.correction_fact = parseInt(this.correction_fact);
            
            this.loading = false;
            
            // Verifica se foi encontrado algum erro
            if(error) {
                return null;
            } else {
                return result;
            }
        },

        nextStep: async function() {
            let form = this.validation();
            
            // Verifica o formado da validação
			if(form == null) {
				return;
            }

            // Confirma se é para roteirzar sem a restrição de peso
            if(!form.time_constraints) {
                // Verifica se os campos de início e término do almoço estão preenchudos
                if((form.start_lunch_time != "") && (form.end_lunch_time != "")) {
                    // Apresenta a confirmação
                    let confirm = await this.$alert.confirm("O horário do almoço será desconsiderado devido aos campos de início e término das entregas estarem vazios. - SOMENTE SERÁ CONSIDERADA A RESTRIÇÃO DE TEMPO SE OS HORÁRIOS ESTIVEREM PREENCHIDOS - Deseja continuar?", "AVISO");
                    if(!confirm) {
                        return;
                    }
                } else {
                    // Apresenta a confirmação
                    let confirm = await this.$alert.confirm("Os horários de início e término das entregas estão vazios. - SOMENTE SERÁ CONSIDERADA A RESTRIÇÃO DE TEMPO SE OS HORÁRIOS ESTIVEREM PREENCHIDOS - Deseja continuar?", "AVISO");
                    if(!confirm) {
                        return;
                    }
                }
            }
            
            if (form != null) {
                this.$emit("next", form);
            }
        },

        cancel: function () {
            this.$emit("cancel");
        },
    }
}
</script>

<style scoped>
.container-heading {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    background-color: #fff;
}

.heading-page {
    padding: 7.5px 10px;
}

.container-body {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    background-color: #fff;
}

.container-button-top {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    background-color: #fff;
}

.container-button-bottom {
    padding: 15px;
    border-top: 1px solid #f0f0f0;
    border-bottom-right-radius: 4px;
    border-bottom-left-radius: 4px;
    background-color: #fff;
}

.button-edit {
    padding: 10px 20px;
	font-size: 14px;
	font-weight: bold;
}

.button-cancel {
    color: #595959;
    background-color: #d9d9d9;
}
</style>